/**
 * Dev-only logger.
 *
 * Use this instead of `console.log` for every developer-debug message in the
 * frontend. The wrapper short-circuits when NODE_ENV === 'production', so
 * production builds carry zero log noise (and CRA's terser pass dead-code-
 * eliminates the call sites entirely).
 *
 * Why not just `console.log`?
 *   1. Customers who open DevTools see no debug clutter.
 *   2. We don't accidentally leak emails / verification codes / mock SMS
 *      payloads into the browser console.
 *   3. Static-analysis tools (and code review bots) stop flagging them.
 *
 * `devError` and `devWarn` are kept loud in production — diagnostic logs
 * for ops are a feature, not noise.
 */
const IS_DEV = process.env.NODE_ENV !== 'production';

export function devLog(...args) {
  if (IS_DEV) console.log(...args);
}

export function devInfo(...args) {
  if (IS_DEV) console.info(...args);
}

export function devDebug(...args) {
  if (IS_DEV) console.debug(...args);
}

// Errors and warnings stay loud in production — useful for operator debugging.
export function devWarn(...args) {
  console.warn(...args);
}

export function devError(...args) {
  console.error(...args);
}
